import Services from "../components/Services";
import Marquee from "../components/Marquee";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

export default function ServicesPage() {
  const { t, dir, lang } = useLanguage();
  const sp = t.servicesPage;
  return (
    <>
      <section
        dir={dir}
        lang={lang}
        className="relative pt-40 pb-10 px-5 sm:px-8"
        data-testid="services-page-hero"
      >
        <div className="mx-auto max-w-7xl">
          <div className="text-[11px] uppercase tracking-[0.3em] text-agency-gold flex items-center gap-3">
            <span className="h-px w-8 bg-agency-gold" /> {sp.eyebrow}
          </div>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="mt-6 font-display text-5xl md:text-7xl font-black tracking-[-0.03em] max-w-4xl"
          >
            {sp.heading1} <span className="gradient-gold-text">{sp.headingGold}</span>{" "}
            {sp.headingRest}
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="mt-6 max-w-2xl text-white/60 text-base md:text-lg"
          >
            {sp.sub}
          </motion.p>
        </div>
      </section>

      <Marquee items={sp.marquee} />
      <Services compact />

      <section
        dir={dir}
        lang={lang}
        className="px-5 sm:px-8 py-24"
        data-testid="services-cta"
      >
        <div className="mx-auto max-w-5xl rounded-2xl border border-white/10 bg-gradient-to-b from-agency-purple/30 via-black to-black p-10 md:p-16 text-center">
          <h2 className="font-display text-3xl md:text-5xl font-black tracking-tight">
            {sp.ctaTitle}
          </h2>
          <p className="mt-4 text-white/60 max-w-xl mx-auto">
            {sp.ctaSub}
          </p>
          <Link
            to="/contact"
            className="mt-8 inline-flex items-center gap-2 bg-agency-gold text-black font-bold uppercase tracking-[0.2em] text-xs px-7 py-4 hover:bg-white transition-colors"
            data-testid="services-page-cta-contact"
          >
            {sp.ctaButton}
          </Link>
        </div>
      </section>
    </>
  );
}
